export function globalInit() {

    // Mockup the delay of subscribing until MailChimp gets figured out by client
    // This one is only on the footer
    $('.btn-subscribe').on('click', function() {

        let msgWrapper = $(this).parents('.input-wrapper');

        if ($(msgWrapper).find('input').val().length) {
            $(msgWrapper).parent().find('.msg-subscribe-empty').removeClass('show');
            $(msgWrapper).append("<p class='msg-subscribe'>You've been subscribed</p>");

            setTimeout(function() {
                $(msgWrapper).parent().find('.msg-subscribe').addClass('show');
            }, 500);
        } else {
            console.log("input email");
            $(msgWrapper).append("<p class='msg-subscribe-empty show'>Please enter an email address</p>");
        }

    });

    // Custom one just for Homepage input. Can be removed once Mailchimp is ready
    $('.btn-subscribe-custom').on('click', function() {
        let msgWrapper = $(this).parents('.input-wrapper');

        if ($(msgWrapper).find('input').val().length) {
            $(msgWrapper).find('.msg-subscribe-empty').removeClass('show');
            $(msgWrapper).find('.msg-subscribe').addClass('show');
        } else {
            $(msgWrapper).find('.msg-subscribe-empty').addClass('show');
            $(msgWrapper).find('.msg-subscribe').removeClass('show');
        }
    });

}